<template lang="pug">
.generic-wrapper
  .container
    h1.title Profile
    .sub-headline Hier sehen Sie alle Details zu Ihrem Profil.

    .card.margin-top(v-if="me")
      .top
        .card-profile-image {{me.firstName[0]}}{{me.lastName[0]}}
        .title.is-5 {{me.firstName}} {{me.lastName}}
        .subtitle.is-6 {{me.email}}
      .main
        b-tabs(type="is-boxed" position="is-centered")
          b-tab-item(label="Stammdaten" icon="text-box-outline")
            .form.center
              b-field(label="Vorname" label-position="on-border")
                b-input(disabled :value="me.firstName")
              b-field(label="Vorname" label-position="on-border")
                b-input(disabled :value="me.lastName")
              b-field(label="E-Mail" label-position="on-border")
                b-input(disabled :value="me.email")
          b-tab-item(label="Passwort aktualisieren" icon="lock-reset")
            .form.center
              ValidationObserver(v-slot="{ handleSubmit }")
                ValidationProvider(name="Altes Passwort" rules="required" v-slot="{ errors, valid }")
                  b-field(label="Altes Passwort" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }")
                    b-input(type="password" v-model="formData.oldPassword")
                ValidationProvider(name="Neues Passwort" rules="required" v-slot="{ errors, valid }")
                  b-field(label="Neues Passwort" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }")
                    b-input(type="password" password-reveal v-model="formData.newPassword")
                ValidationProvider(name="Neues Passwort Wiederholen" rules="required" v-slot="{ errors, valid }")
                  b-field(label="Neues Passwort Wiederholen" label-position="on-border"
                          :type="{ 'is-danger': errors[0], 'is-success': valid }")
                    b-input(type="password" password-reveal v-model="formData.newPasswordRepeat")
                  .error(v-if="formData.newPassword !== formData.newPasswordRepeat") Neue Passwörter stimmen nicht überein.
                .button-wrapper
                  b-button(type="is-primary" @click="handleSubmit(updatePassword)") Passwort aktualisieren
</template>

<script>
export default {
  data() {
    return {
      formData: {
        oldPassword: "",
        newPassword: "",
        newPasswordRepeat: ""
      }
    };
  },
  computed: {
    me() {
      return this.$store.state.me.me;
    }
  },
  methods: {
    async updatePassword() {
      await this.$store.dispatch("me/updatePassword", this.formData);
      this.$store.dispatch("common/showSuccess", "Passwort erfolgreich aktualisiert.");
    }
  }
};
</script>

<style lang="scss" scoped>
.card-profile-image {
  height: 120px;
  width: 120px;
  background-color: pink;
  border: solid 1px $light;
  border-radius: 100%;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: $sm-space;
}

.card .top {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: $sm-space;
}

.button-wrapper {
  margin-top: $sm-space;
}
</style>